/*
  Useful functions
*/

import axios from 'axios'
import EXIF from 'exif-js'

export async function delay (ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function getLocal (key = '', fallback = false) {
  if (!window.localStorage) return fallback
  return window.localStorage.getItem(key) || fallback
}

export function createObjectURL (fileOrBlob) {
  return (window.URL || window.webkitURL).createObjectURL(fileOrBlob)
}

export function revokeObjectURL (href) {
  (window.URL || window.webkitURL).revokeObjectURL(href)
}

export function getLocationFromDevice () {
  return new Promise((resolve, reject) => {
    const onSuccess = location => {
      resolve(location)
    }

    const onError = error => {
      reject(error)
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError, {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0 // 1000 * 60
      })
    } else {
      onError(new Error('Geo Location not supported by browser'))
    }
  })
}

export function getLocationFromEXIF (file) {
  return new Promise((resolve, reject) => {
    try {
      EXIF.getData(file, function() {
        const latVals = EXIF.getTag(this, 'GPSLatitude')
        const lonVals = EXIF.getTag(this, 'GPSLongitude')

        const latDir = EXIF.getTag(this, 'GPSLatitudeRef')
        const lonDir = EXIF.getTag(this, 'GPSLongitudeRef')

        if (latVals && lonVals && latDir && lonDir) {
          // Conversion form EXIF to decimal lat/lon from:
          // https://awik.io/extract-gps-location-exif-data-photos-using-javascript/

          const latDeg = latVals[0].numerator / latVals[0].denominator
          const latMin = latVals[1].numerator / latVals[1].denominator
          const latSec = latVals[2].numerator / latVals[2].denominator
          console.log(latVals)
          console.log(latDeg + '°' + latMin + '\'' + latSec + '"' + latDir)
          var latFinal = ConvertDMSToDD(latDeg, latMin, latSec, latDir)

          const lonDeg = lonVals[0].numerator / lonVals[0].denominator
          const lonMin = lonVals[1].numerator / lonVals[1].denominator
          const lonSec = lonVals[2].numerator / lonVals[2].denominator
          console.log(lonVals)
          console.log(lonDeg + '°' + lonMin + '\'' + lonSec + '"' + lonDir)
          var lonFinal = ConvertDMSToDD(lonDeg, lonMin, lonSec, lonDir)

          resolve({
            latitude: latFinal,
            longitude: lonFinal
          })
        } else {
          resolve(null)
        }
      })
    } catch (err) {
      reject(err)
    }
  })
}

export function deg2rad (deg) {
  return deg * (Math.PI / 180)
}

export function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d;
}

export async function reverseGeo (lat, lon) {
  try {
    const apiRoot = process.env.VUE_APP_API_DOMAIN
    const res = await axios(`${apiRoot}/wp-json/ac/v1/reverse-geocode`, {
      params: {
        lat: lat,
        lon: lon
      }
    })

    // console.log(res.data)

    const a = res.data.address
    if (!a) return ''

    let location
    if (a.city && a.country) {
      location = a.city + ', ' + a.country
    } else if (a.state && a.country) {
      location = a.state + ', ' + a.country
    } else if (a.country) {
      location = a.country
    } else {
      location = res.data.display_name
    }
    return location
  } catch (err) {
    throw err
  }
}

export function formatLocation ({
  village,
  town, city,
  county,
  state,
  country,
  country_code,
  continent
}) {
  let name = []
  let t = village || town || city || county
  t && name.push(t)
  if (city !== t && city) {
    name.push(city)
  }
  if (state !== city && state) {
    name.push(state)
  }
  if (country && country.length > 9) {
    name.push(country_code.toUpperCase())
  } else {
    country && name.push(country)
  }
  if (!name.length && continent) {
    name.push(continent)
  }
  return name.join(', ')
}

function ConvertDMSToDD (degrees, minutes, seconds, direction) {
  var dd = degrees + (minutes/60) + (seconds/3600)
  if (direction == "S" || direction == "W") {
    dd = dd * -1
  }
  return dd
}
